import styles from "../CriarLoja/CriarLoja.module.css";
import {useState, ChangeEvent, FormEvent} from "react";
import { FaPlusSquare } from "react-icons/fa";

import api from "../../utils/axios/api";

export default function CriarLoja(){

  const [image, setImage] = useState<string | null>('');
  const [name, setName] = useState("");
  const [termoDeUso, setTermoDeUso] = useState("");
  console.log("linha 15");
  const handleFileChange = (event: ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];

    if (file) {
      const imageUrl = URL.createObjectURL(file);
      //como fazer com arquivo? 
      setImage(imageUrl);
    }

  };

  function handleCreate(e:FormEvent){
    e.preventDefault()
    if(!image || !name || !termoDeUso){
      return alert("Preencha todos os campos!");
    } 
    api.post('/store',{image,name,termoDeUso})
    .then(() => {console.log("ok");
      alert("Usuario cadastrado com sucesso!");})
    .catch(error => { console.log("erro");
      if(error.response){
        alert(error.responde.message);
      }
      else {(alert("Não foi possível cadastrar"));
    }
    })
  }
  

    return(
      <div className={styles.centeringModal}>
        <div className={styles.containerModal}>
          <h1 className={styles.h1}>Criar Loja</h1>
              <form onSubmit={handleCreate} className={styles.forms}>
                  <div className={styles.centeredItens}>
                   <label htmlFor="imagemInput"><strong>ícone da Loja</strong></label>
                   <br></br>
                   <div style={{ position: 'relative', display: 'inline-block' }}>
                    {image && (
                      <img
                        src={image}
                        style={{ maxWidth: '20vh', borderRadius: '10px', maxHeight: '20vh' }}
                      />
                    )}
                    {(
                      <label htmlFor="uploadInput">
                        <input
                          type="file"
                          id="uploadInput"
                          style={{ display: 'none' }}
                          onChange={handleFileChange}
                          accept="image/*"
                        />
                        <FaPlusSquare
                          style={{
                            position: 'absolute',
                            top: '10%',
                            left: '90%',
                            transform: 'translate(-50%, -50%)',
                            fontSize: '24px',
                            color: 'blue', // Altere a cor conforme necessário
                            cursor: 'pointer', // Adicione um cursor indicando que é clicável
                          }}
                        />
                      </label>
                    )}
                    </div>

                  </div>
                  <br></br>
                  <label htmlFor="nomeLoja"><strong>Nome da Loja</strong></label>
                  <br></br>
                  <input type="text" id="nomeLoja" name="nomeLoja" onChange={e => setName(e.target.value)} placeholder="Digite o nome da loja" required/>
                  <br></br>
                  <label><strong> Concordo com os</strong>
                    <a href="termos-de-uso.html" target="_blank"><strong> Termos de Uso</strong></a>
                    <div className="concordo"><input className={styles.checkedbox} type="checkbox" id="concordo" name="concordo" onChange={e=> setTermoDeUso(e.target.value)} value="Concordo"/> Eu concordo</div> 
                  </label>
                  <button type="submit">Criar loja</button>
              </form>
        </div>
      </div>
    );
  }